import { render, staticRenderFns } from "./usrmenu.vue?vue&type=template&id=a38ae8c8&scoped=true"
import script from "./usrmenu.vue?vue&type=script&lang=js"
export * from "./usrmenu.vue?vue&type=script&lang=js"
import style0 from "./usrmenu.vue?vue&type=style&index=0&id=a38ae8c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a38ae8c8",
  null
  
)

export default component.exports